<ns-grid
  [loading]="loading"
  rowSelection="multiple"
  [gridOptions]="gridOptions"
  [config]="gridConfig"
  [data]="carDetails"
  (ready)="setUpGrid($event)"
  (selectedRows)="selectionChange($event)"
>
  <div class="w-100 d-flex justify-content-between" grid-header>
    <span>Car Details for Invoice: {{ invoiceNumber || '' }}</span>
    <div>
      <button mat-stroked-button [disabled]="selectedRows.length === 0" color="warn" (click)="resetGrid()" aria-label="Clear">Clear</button>
      <button class="mx-2" mat-flat-button color="accent" (click)="submitDispute()" [disabled]="isDisputeDisabled" aria-label="dispute">
        Dispute
      </button>
      <button mat-flat-button color="accent" (click)="navigateBack()" aria-label="cancel">Return</button>
    </div>
  </div>
</ns-grid>
